<template>
  <b-navbar
    toggleable="lg"
    :variant="layoutNavbarBg"
    class="layout-navbar align-items-lg-center container-p-x"
  >
    <div class="d-flex justify-content-between w-100">
      <!-- Brand Title (Aligned Left) -->
      <b-navbar-brand tag="h1" class="mb-2 mt-2">Skittles Vending</b-navbar-brand>

      <!-- Toggle button for sidenav (visible on small screens) -->
      <b-navbar-nav
        class="layout-sidenav-toggle d-lg-none align-items-lg-center mr-auto"
        v-if="sidenavToggle"
      >
        <a
          class="nav-item nav-link px-0 mr-lg-4"
          href="javascript:void(0)"
          @click="toggleSidenav"
        >
          <i class="ion ion-md-menu text-large align-middle"></i>
        </a>
      </b-navbar-nav>

      <!-- Right Aligned Profile Dropdown --> 
      <b-collapse is-nav id="app-layout-navbar" class="d-flex justify-content-end align-items-center">
        <b-dropdown right variant="link" class="profile-dropdown pl-2 " size="sm" no-caret>
          <template #button-content>
            <b-button variant="link" class="no-bg no-border p-0" style="text-decoration: none;">
              <span class="no-underline">{{ auth.state.user.name }}</span>
            </b-button>
          </template>
        <b-dropdown-item @click="handleLogout" class="no-border">
            <i class="ion ion-ios-log-out text-danger"></i>
            &nbsp; Logout
          </b-dropdown-item>
        </b-dropdown>
      </b-collapse>
      <b-avatar class="mt-2" size="2.5rem"  variant="light" :src="auth.state.user.picture" />
    </div>  </b-navbar></template>

<script>
import { defineComponent, ref, computed, inject } from "vue"; 
import { BDropdown, BDropdownItem, BNavbar, BNavbarBrand, BNavbarNav, BCollapse, BAvatar } from "bootstrap-vue-next";

export default defineComponent({
  name: "AppLayoutNavbar",
  components: {
    BDropdown,
    BDropdownItem,
    BNavbar,
    BNavbarBrand,
    BNavbarNav,
    BCollapse,
    BAvatar 
  },
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const layoutHelpers = inject('layoutHelpers'); // Inject layoutHelpers
    const auth = inject('auth'); // Inject the auth object

    const userName = ref("John Doe"); // Example login name

    const toggleSidenav = () => {
      layoutHelpers?.toggleCollapsed(); // Optional chaining to avoid errors
    };

    const layoutNavbarBg = computed(() => {
      return layoutHelpers?.layoutNavbarBg || 'defaultVariant'; // Provide a default value
    });

    const handleLogout = () => {
      auth.logout({
        returnTo: window.location.origin,
      });
    };

    return {
      userName,
      toggleSidenav,
      layoutNavbarBg,
      handleLogout,
      auth, // Expose auth to the template if needed
    };
  },
});
</script>


<style scoped>
/* Optional: Add styles to adjust the layout or spacing if necessary */
.profile-dropdown .dropdown-toggle {
  cursor: pointer;
}
 

.dropdown-item {
  border: none !important; /* Ensure dropdown item has no border */
  text-decoration: none !important; /* Ensure no underline */
}

.no-underline
 {
  text-decoration: none !important; /* Ensure no underline on span */
  color: rgb(84, 84, 84) !important; /* Set text color to black */
}

.no-underline:hover {
  color: rgb(6, 6, 6) !important; /* Change color on hover */
}
 
.no-bg {
  background: transparent !important;
}
.no-border {
  border: none !important;
}
</style>
